import React, { forwardRef } from 'react';
import { HeaderModelData } from 'types/model';
import { Divider } from 'fronton-react';
import {
  MagnifyingGlassIcon,
  BookmarkSimpleIcon,
  LeroyMerlinStoreIcon,
  ShoppingCartSimpleIcon,
} from '@fronton/icons-react';
import { useLocation } from '@okapi/router-react';
import { useMobileMenuAnalyticsEvent } from 'components/header/hooks';
import { MobileMenuLink } from './mobile-menu-link';
import { wrapper, root, dividerFix } from './styles';
import { matchRoute } from './utils';
import { BasketMenuLink } from './basket-menu-link';
import { MobileUserMenu } from './mobile-user-menu';

export type MenuMobileProps = {
  model: HeaderModelData;
};

export const MenuMobile = forwardRef<HTMLDivElement, MenuMobileProps>(({ model }, ref) => {
  const { home, shoppingList, shops, initUrl } = model.header;

  const [location] = useLocation();

  const getIsActive = (href: string) => matchRoute(location, href);

  const onMainPageLinkClick = useMobileMenuAnalyticsEvent('Главная');
  const onShoppingListLinkClick = useMobileMenuAnalyticsEvent('Мой список');
  const onShopsLinkClick = useMobileMenuAnalyticsEvent('Магазины');

  return (
    <div className={wrapper} data-qa="mobile-fixed-menu" ref={ref}>
      <Divider className={dividerFix} />
      <div className={root}>
        <MobileMenuLink
          icon={MagnifyingGlassIcon}
          href={home}
          text="Главная"
          getIsActive={getIsActive}
          data-qa="mobile-menu-home-link"
          onClick={onMainPageLinkClick}
        />
        <MobileMenuLink
          icon={BookmarkSimpleIcon}
          href={shoppingList}
          text="Мой список"
          getIsActive={getIsActive}
          data-qa="mobile-menu-shopping-list-link"
          onClick={onShoppingListLinkClick}
        />
        <MobileMenuLink
          icon={LeroyMerlinStoreIcon}
          href={shops}
          text="Магазины"
          getIsActive={getIsActive}
          data-qa="mobile-menu-shops-link"
          onClick={onShopsLinkClick}
        />

        <MobileUserMenu href={initUrl} shoppingListUrl={shoppingList} />

        <BasketMenuLink
          icon={ShoppingCartSimpleIcon}
          href="/basket/"
          text="Корзина"
          getIsActive={getIsActive}
          data-qa="mobile-menu-basket-link"
        />
      </div>
    </div>
  );
});
